import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Layout } from './components/layout/Layout'
import { LoadingFallback } from './components/LoadingFallback'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { OnboardingGuard } from './components/auth/OnboardingGuard'

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/Home').then(module => ({ default: module.Home })))
const Closet = lazy(() => import('./pages/Closet').then(module => ({ default: module.Closet })))
const Stylist = lazy(() => import('./pages/Stylist').then(module => ({ default: module.Stylist })))
const Trip = lazy(() => import('./pages/Trip').then(module => ({ default: module.Trip })))
const Profile = lazy(() => import('./pages/Profile').then(module => ({ default: module.Profile })))
const Pricing = lazy(() => import('./pages/Pricing').then(module => ({ default: module.Pricing })))
const Onboarding = lazy(() => import('./pages/Onboarding').then(module => ({ default: module.Onboarding })))
const Login = lazy(() => import('./pages/Auth').then(module => ({ default: module.Login })))
const Signup = lazy(() => import('./pages/Auth').then(module => ({ default: module.Signup })))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      gcTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/signup" element={<Signup />} />

            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              }
            />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <OnboardingGuard>
                    <Layout />
                  </OnboardingGuard>
                </ProtectedRoute>
              }
            >
              <Route index element={<Home />} />
              <Route path="closet" element={<Closet />} />
              <Route path="stylist" element={<Stylist />} />
              <Route path="trip" element={<Trip />} />
              <Route path="profile" element={<Profile />} />
              <Route path="pricing" element={<Pricing />} />
            </Route>

            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
